import { NotePriority, NoteType } from '../enums';
import { Assignee } from '../types';

export const NoteTypeData: Record<NoteType, { label: string; color: string | null }> = {
  [NoteType.PreventiveMaintenance]: {
    label: 'Preventive maintenance',
    color: '#12B76A',
  },
  [NoteType.Fault]: {
    label: 'Fault',
    color: '#D92D20',
  },
  [NoteType.General]: {
    label: 'General',
    color: null,
  },
} as const;

export const teams: Assignee[] = [
  {
    name: 'Team 1',
    id: 'team1',
    color: '#0BA5EC',
  },
  {
    name: 'Team 2',
    id: 'team2',
    color: '#FEC84B',
  },
  {
    name: 'Team 3',
    id: 'team3',
    color: '#F63D68',
  },
];

export const priorityLabels: Record<NotePriority, string> = {
  [NotePriority.Highest]: 'Immediate',
  [NotePriority.High]: 'Within a Day',
  [NotePriority.Medium]: 'Within a Week',
  [NotePriority.Low]: 'Within a Month',
  [NotePriority.Lower]: 'Within 3 Months',
  [NotePriority.Lowest]: 'Annual',
};
